import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Fuse from 'fuse.js';

export const CATEGORY_HINT = 'Filters this Circle’s public page, app feed, and nightly latest-finds and weekly new-products emails.';

function CircleCategory({ circle, industries, disabled, onChange, label = 'Primary category' }) {
  const [search, setSearch] = useState('');
  const groups = useMemo(
    () => [
      { value: '-', label: 'Everything' },
      ...industries.map(industry => ({
        label: industry.name,
        options: [
          { value: `${industry.id}-`, label: `All ${industry.name}`, industry: industry.name },
          ...industry.departments.map(department => ({
            value: `${industry.id}-${department.id}`,
            label: department.name,
            industry: industry.name
          }))
        ]
      }))
    ],
    [industries]
  );
  const options = useMemo(() => groups.flatMap(group => group.options || [group]), [groups]);
  const fuse = useMemo(() => new Fuse(options, { keys: ['label', 'industry'], threshold: 0.35, ignoreLocation: true }), [options]);
  const matches = search.trim() ? new Set(fuse.search(search.trim()).map(result => result.item.value)) : null;
  const filteredGroups = matches
    ? groups
        .map(group => (group.options ? { ...group, options: group.options.filter(option => matches.has(option.value)) } : group))
        .filter(group => (group.options ? group.options.length : matches.has(group.value)))
    : groups;
  const categoryValue = circle.Category_id ? `legacy-${circle.Category_id}` : `${circle.Industry_id || ''}-${circle.Department_id || ''}`;
  const selected = options.find(option => option.value === categoryValue) || {
    value: categoryValue,
    label: circle.Category_id ? 'Legacy category (pick another to replace it)' : 'Current category (unavailable)'
  };

  return (
    <Select
      className='circle-category-select'
      classNamePrefix='circle-category-select'
      value={selected}
      options={filteredGroups}
      inputValue={search}
      onInputChange={setSearch}
      filterOption={null}
      isDisabled={disabled}
      isSearchable
      aria-label={label}
      aria-describedby='circle-category-hint'
      placeholder='Search categories…'
      noOptionsMessage={() => 'No matching categories'}
      menuPortalTarget={document.body}
      menuPlacement='auto'
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999, fontSize: 12 }) }}
      onChange={option => {
        const [industry, department] = option.value.split('-');
        onChange({ Industry_id: Number(industry) || null, Department_id: Number(department) || null, Category_id: null });
      }}
    />
  );
}

CircleCategory.propTypes = {
  circle: PropTypes.object.isRequired,
  industries: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string
};

export default CircleCategory;
